module.exports = "static/assets/40167d33efb7d0929a3bcbc591fc78b0.svg";